/*
    加工コードを選択するリスト
*/
import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";

export type ProcCodeSelectProp = {
  // ラベル
  label: string;
  // 工場コード
  plantCode: string;
  // 選択中の加工コード
  selectProcCode: string;
  // 加工コードが選択された場合のイベント処理
  handleProcCodeChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  // 特定の加工コードのみ選択可能にしたい場合はfilterに加工コードのリストをセット
  filter?: string[];
  // 値を変更した状態の表示か（枠線の色を変更）
  isValueChangeState?: boolean;
};

interface Option {
  code: string;
  name: string;
}

export const ProcCodeSelect: React.FC<ProcCodeSelectProp> = ({
  label,
  plantCode,
  selectProcCode,
  handleProcCodeChange,
  filter = [],
  isValueChangeState = false,
}) => {
  // このコンポーネントでユニークなID
  const id =
    "select-proc-code-" +
    new Date().getTime().toString(16) +
    Math.floor(1000 * Math.random()).toString(16);
  // 工場・加工・機械マスタデータ
  const plant_proc_mach = useSelector(
    (state: RootState) => state.procs.plantProcMach
  );
  let procCodeOptions: Option[] = plant_proc_mach
    .filter((item) => item.plant_code === plantCode)
    .map((item) => ({
      code: item.proc_code,
      name: item.proc_name,
    }));
  // 特定の加工コードのみ選択可能にする処理
  if (filter.length > 0) {
    procCodeOptions = procCodeOptions.filter((d) => filter.includes(d.code));
  }

  return (
    <>
      {label !== "" ? <label htmlFor={id}>{label}</label> : null}
      <select
        id={id}
        onChange={handleProcCodeChange}
        value={selectProcCode}
        className={
          isValueChangeState
            ? "value-change-state-select input-110"
            : "input-110"
        }
      >
        <option value="">-</option>
        {procCodeOptions.map(({ code, name }, index) => (
          <option key={index} value={code}>{`${code}: ${name}`}</option>
        ))}
      </select>
    </>
  );
};
